import { Link } from "react-router-dom";
import CompanyIntro from "assets/banner/company_intro.png";
import BranchIntro from "assets/banner/branch_intro.png";
import BranchIntro2 from "assets/banner/branch_intro2.png";
import { twMerge } from "tailwind-merge";

const BannerNotice = ({ type, className }: { type?: keyof typeof buttonStyleMap; className?: string }) => {
    const buttonStyleMap = {
        air: "bg-express",
        express: "bg-morning",
        morning: "bg-express",
        quick: "bg-express",
    };
    return (
        <div className={twMerge("w-[588px] h-[262px] gap-6 flex", className)}>
            <Link to="/company/ceo-message" className="w-full h-full bg-white relative border rounded-[20px] pt-[32px] px-[38px]">
                <p className="text-[22px] font-bold text-[#333] pb-[15px]">회사소개</p>
                <p className="text-sm text-[#666] pb-[42px]">
                    언제나 여러분 곁에 <br /> 자리매김할 것을 <br /> 약속 드립니다.
                </p>
                <div className="text-sm text-white w-[98px] text-center py-[5px] rounded-full bg-[#264180] text-[500]">바로가기</div>
                <img className="absolute top-[56px] right-0" src={CompanyIntro} alt="CompanyIntro" />
            </Link>
            <Link
                to="/company/branch"
                className="w-full h-full bg-white relative border rounded-[20px] overflow-hidden pt-[32px] px-[38px]"
            >
                <p className="text-[22px] font-bold text-[#333] pb-[15px]">BRANCH</p>
                <p className="text-sm text-[#666] pb-[42px]">
                    성공을 위해 노력하는 <br /> 1위 글로벌 기업으로 <br /> 성장하겠습니다.
                </p>
                <div className={`text-sm text-white w-[98px] text-center py-[5px] rounded-full ${type && buttonStyleMap[type]} text-[500]`}>
                    바로가기
                </div>
                <img className="absolute top-0 right-0" src={type === "express" ? BranchIntro2 : BranchIntro} alt="BranchIntro" />
            </Link>
        </div>
    );
};

export default BannerNotice;
